import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { LANGS } from "@/i18n/strings";

// Simplified round flags drawn on a 16x16 box.
const FLAGS = {
  nb: (
    <>
      <rect width="16" height="16" fill="#BA0C2F" />
      <path d="M0 6h16v4H0zM4 0h4v16H4z" fill="#fff" />
      <path d="M0 7h16v2H0zM5 0h2v16H5z" fill="#00205B" />
    </>
  ),
  en: (
    <>
      <rect width="16" height="16" fill="#012169" />
      <path d="M0 0L16 16M16 0L0 16" stroke="#fff" strokeWidth="3.2" />
      <path d="M0 0L16 16M16 0L0 16" stroke="#C8102E" strokeWidth="1.2" />
      <path d="M8 0v16M0 8h16" stroke="#fff" strokeWidth="4.4" />
      <path d="M8 0v16M0 8h16" stroke="#C8102E" strokeWidth="2.4" />
    </>
  ),
  zh: (
    <>
      <rect width="16" height="16" fill="#EE1C25" />
      <path d="M4.6 2.6l.8 2.4h2.5l-2 1.5.8 2.4-2.1-1.5-2 1.5.7-2.4-2-1.5h2.5z" fill="#FFDE00" />
      {[[9.2, 2.6], [10.6, 4.6], [10.6, 7], [9.2, 8.9]].map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="0.75" fill="#FFDE00" />
      ))}
    </>
  ),
  ru: (
    <>
      <rect width="16" height="5.4" fill="#fff" />
      <rect y="5.3" width="16" height="5.4" fill="#0039A6" />
      <rect y="10.6" width="16" height="5.4" fill="#D52B1E" />
    </>
  ),
  se: (
    <>
      <rect width="16" height="16" fill="#0035AD" />
      <rect width="6.6" height="16" fill="#DC241F" />
      <rect x="6.6" width="1" height="16" fill="#007229" />
      <rect x="7.6" width="1" height="16" fill="#FFCE00" />
      <path d="M7.6 3.7a4.3 4.3 0 0 0 0 8.6" fill="none" stroke="#0035AD" strokeWidth="1.5" />
      <path d="M7.6 3.7a4.3 4.3 0 0 1 0 8.6" fill="none" stroke="#DC241F" strokeWidth="1.5" />
    </>
  ),
  th: (
    <>
      <rect width="16" height="16" fill="#A51931" />
      <rect y="2.67" width="16" height="10.66" fill="#F4F5F8" />
      <rect y="5.33" width="16" height="5.34" fill="#2D2A4A" />
    </>
  ),
};

export const LangFlags = ({ className = "" }) => {
  const { lang, setLang, t } = useLang();
  return (
    <div className={`flex items-center gap-1.5 ${className}`} role="group" aria-label={t.langSwitch} data-testid="lang-flags">
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          title={l.label}
          aria-label={l.label}
          aria-pressed={lang === l.code}
          data-testid={`lang-flag-${l.code}`}
          onClick={() => setLang(l.code)}
          className="p-[3px] rounded-full transition-transform duration-200 hover:scale-110 active:scale-95"
        >
          <svg
            viewBox="0 0 16 16"
            className={`block w-[18px] h-[18px] rounded-full overflow-hidden transition-[box-shadow,opacity] duration-200 ${
              lang === l.code ? "shadow-[0_0_0_2px_#F7F5F0,0_0_0_3.5px_#2E2A25]" : "opacity-60 hover:opacity-100 shadow-[0_0_0_1px_rgba(46,42,37,0.25)]"
            }`}
          >
            <clipPath id={`flag-${l.code}`}><circle cx="8" cy="8" r="8" /></clipPath>
            <g clipPath={`url(#flag-${l.code})`}>{FLAGS[l.code]}</g>
          </svg>
        </button>
      ))}
    </div>
  );
};
